import React, {
  FocusEvent,
} from 'react';
import clsx from 'clsx';
import MaskedTextField from 'core/components/MaskedTextField';
import UnitedStateFlag from 'core/icons/unitedStateFlag';
import InputAdornment from '@mui/material/InputAdornment';
import {
  TextFieldProps,
} from '@mui/material/TextField';

const mask = [{
  mask: '{+1} (000) 000-0000',
  lazy: false,
  overwrite: true,
}];

type Props = TextFieldProps & {
  value?: string | null;
  placeholder?: string;
  disabled?: boolean;
  required?: boolean;
  readonly?: boolean;
  error?: boolean;
  name: string;
  id: string;
  className?: string;
  inputClassName?: string;
  onChange: (val: string) => void;
  onFocus?: (e: FocusEvent<HTMLInputElement>) => void;
  onBlur?: (e: FocusEvent<HTMLInputElement>) => void;
};

export default function PhoneInput({
  value,
  placeholder,
  disabled,
  required,
  onChange,
  className,
  inputClassName,
  readonly: readOnly,
  error,
  ...props
}: Props) {
  const classes = clsx('flex items-center w-full overflow-hidden rounded');

  return (
    <div className={classes}>
      <MaskedTextField
        {...props}
        disabled={disabled}
        mask={mask}
        value={value ?? ''}
        onAccept={onChange}
        className={clsx('populate-phone-input', className)}
        slotProps={{
          input: {
            startAdornment: (
              <InputAdornment position="start" className="-ml-1.5">
                <UnitedStateFlag className="!text-base" />
              </InputAdornment>
            ),
          },
          htmlInput: {
            inputMode: 'tel',
            autoComplete: 'tel-national',
          },
        }}
      />
    </div>
  );
}
